export default "Serres chauffées, froid agricole, irrigation : votre exploitation est peut-être électro-intensive au sens fiscal. Taux réduits d'accise (ex-CSPE) et remboursement rétroactif — vérification gratuite.";
